package app.nestbridge.feature.profile.ui

import app.nestbridge.feature.profile.screen.CreateUserProfileScreen
import app.nestbridge.feature.profile.screen.CreateUserProfileState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class CreateUserProfileUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is CreateUserProfileScreen -> ui<CreateUserProfileState> { state, modifier -> CreateUserProfileUi(state = state, modifier = modifier) }
    else -> null
  }
}
